import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/menu.svg';

export const IconMenu: IconComponent = props => <Icon {...props} src={src} />;
